module.exports = "/assets/0b1aab765584745002eb82b33e49a091.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OU.png
// module id = 2817
// module chunks = 0